module.exports = __webpack_public_path__ + "a768e7de/img/upload-icon.9179ae4e.svg";